import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import {
	CreditBureauAddress,
	AddressType,
	SpecialAddressIndicator,
	Country,
	MexState
} from '@/graphql/__generated__/onboarding';
import {
	getAddressTypeText,
	getSpecialAddressIndicatorText,
	getMexStateText,
	getCountryText
} from './mapUtils';
import ExpandableTable from './ExpandableTable';

interface AddressesProps {
	addresses?: CreditBureauAddress[] | null | undefined;
}

const Addresses: React.FC<AddressesProps> = ({ addresses }) => {
	const t = useTranslations('CreditBureau');
	const stateT = useTranslations('States');
	const countryT = useTranslations('Countries');

	if (!addresses || addresses.length === 0) return null;

	// Create new objects with translated keys and mapped values
	const translatedData = addresses.map((address) => {
		return Object.entries(address)
			.filter(([key]) => key !== '__typename')
			.reduce(
				(acc, [key, value]) => {
					const translatedKey = t(toTranslationKey(key));

					// Map special fields
					if (key === 'addressType' && value) {
						acc[translatedKey] = getAddressTypeText(value as AddressType, t);
					} else if (key === 'specialAddressIndicator' && value) {
						acc[translatedKey] = getSpecialAddressIndicatorText(
							value as SpecialAddressIndicator,
							t
						);
					} else if (key === 'countryCode' && value) {
						acc[translatedKey] = getCountryText(value as Country, countryT);
					} else if (key === 'stateCode' && value) {
						acc[translatedKey] = getMexStateText(value as MexState, stateT);
					} else {
						acc[translatedKey] = value;
					}

					return acc;
				},
				{} as Record<string, any>
			);
	});

	return (
		<ExpandableTable title={t('Addresses')}>
			<div className="max-w-4xl">
				<FlexibleTable data={translatedData} />
			</div>
		</ExpandableTable>
	);
};

export default Addresses;
